// English translations
export default {
  common: {
    loading: "Loading...",
    error: "Error",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    close: "Close",
    yes: "Yes",
    no: "No",
    submit: "Submit",
    clear: "Clear",
    refresh: "Refresh",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    actions: "Actions",
    status: "Status",
    details: "Details",
    noData: "No data",
    connectionLost: "Connection lost. Attempting to reconnect..."
  },

  login: {
    title: "CODED CITIES",
    subtitle: "Log in your team",
    teamName: "Team Name",
    password: "Password",
    passwordOptional: "",
    teamNamePlaceholder: "Enter your team name",
    passwordPlaceholder: "Enter password",
    joinGame: "Join Game",
    joiningGame: "Joining...",
    readyToExplore: "Ready to play? START!",
    startAdventure: "",
    adminAccess: "Admin Access"
  },

  adminLogin: {
    title: "Admin Panel",
    subtitle: "Log in to manage the game",
    username: "Username",
    password: "Password",
    usernamePlaceholder: "Enter username",
    passwordPlaceholder: "Enter password",
    login: "Log In",
    loggingIn: "Logging in...",
    backToGame: "Back to game"
  },

  dashboard: {
    title: "Team Dashboard",
    yourTeamIs: "Your team is:",
    welcome: "Welcome",
    totalPoints: "Points",
    completed: "Completed",
    position: "Position",
    gameActive: "Game Active",
    gameFinished: "Game Finished",
    gameNotStarted: "Game Not Started",
    waitingForStart: "Waiting for the game to start...",
    congratulations: "Congratulations!",
    gameCompleted: "You completed the game!",
    finalScore: "Final Score",
    tabs: {
      game: "Game",
      ranking: "Ranking",
      stats: "Stats",
      teams: "Teams",
      chat: "Chat"
    },
    stopGame: {
      title: "Stop game early?",
      message: "Are you sure you want to stop the game? This action cannot be undone.",
      confirm: "Yes, stop game",
      cancel: "Cancel"
    },
    logout: "Log out",
    // New keys for completion section
    allPuzzlesSolved: "All puzzles solved!",
    writeDigits: "Write down digits from tiles and calculate stop code using the formula card.",
    stopClock: "STOP THE CLOCK!",
    yourTime: "Your time",
    waitForAnnouncement: "Wait for results announcement. Thank you for participating!",
    youCompletedGame: "you completed the game!"
  },

  gameProgress: {
    title: "Game Progress",
    challenges: "Challenges",
    challengesCompleted: "Challenges completed",
    pointsEarned: "Points earned",
    attemptsUsed: "Attempts used",
    currentChallenge: "Current challenge",
    nextChallenge: "Next challenge",
    noMoreChallenges: "No more challenges",
    status: {
      correct: "Correct",
      incorrect: "Incorrect",
      submitted: "Pending",
      notAttempted: "Not attempted"
    },
    tile: "Tile",
    points: "pts",
    attempts: "attempts",
    // New keys
    yourProgress: "Your progress",
    gameCompleted: "You completed the game!",
    congratsWaitResults: "Congratulations! Wait for results.",
    gameNotStartedYet: "Game not started yet",
    waitForOperator: "Wait for the operator to start",
    gameEnded: "Game ended",
    thankYou: "Thank you for participating!",
    gamePaused: "Game paused",
    waitForResume: "Wait for resume",
    gameInactive: "Game inactive",
    tilesUnlocked: "Tiles will unlock when game starts",
    // Tile labels
    questionLabel: "Question",
    digitForCode: "Digit for code",
    tapToOpen: "Tap",
    noPuzzles: "No puzzles",
    waitForGameStart: "Wait for game to start"
  },

  // New section for tile modal
  tileModal: {
    questionNumber: "Question",
    enterAnswer: "Enter answer and check",
    answerPlaceholder: "Enter answer...",
    correct: "Well done!",
    incorrect: "Sorry...",
    wrongAnswer: "Wrong answer. Try again!",
    connectionError: "Connection error. Try again.",
    digitForCode: "Digit for code",
    checking: "Checking...",
    checkAnswer: "Check answer"
  },

  answerForm: {
    title: "Submit Answer",
    tileNumber: "Tile Number",
    tileNumberPlaceholder: "Enter tile number",
    yourAnswer: "Your Answer",
    answerPlaceholder: "Enter your answer...",
    submit: "Submit Answer",
    submitting: "Submitting...",
    clear: "Clear",
    hint: "Make sure the tile number is correct before submitting.",
    successMessage: "Answer submitted successfully!",
    errorMessage: "Failed to submit answer. Please try again."
  },

  ranking: {
    title: "Ranking",
    position: "Pos.",
    team: "Team",
    points: "Points",
    completed: "Completed",
    lastActivity: "Last Activity",
    yourTeam: "Your team",
    noTeams: "No teams in ranking",
    medals: {
      gold: "Gold",
      silver: "Silver",
      bronze: "Bronze"
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      finished: "Finished"
    }
  },

  timer: {
    timeRemaining: "Time remaining",
    timeAlmostUp: "Time almost up!",
    timeRunningLow: "Time running low",
    gameEnded: "Game ended",
    hours: "hrs",
    minutes: "min",
    seconds: "sec"
  },

  stats: {
    title: "Game Statistics",
    totalTeams: "Total teams",
    activeTeams: "Active teams",
    totalAnswers: "Total answers",
    correctAnswers: "Correct answers",
    averageScore: "Average score",
    topScore: "Top score",
    completionRate: "Completion rate",
    averageTime: "Average time",
    totalPoints: "Points",
    solved: "Solved",
    position: "Position",
    attempts: "Attempts",
    progressSummary: "Progress Summary",
    collectedDigits: "Collected Digits",
    allSolved: "All questions solved!",
    checkStopCode: "Check the stop code",
    noData: "No data",
    waitingForGame: "Waiting for game to start"
  },

  admin: {
    title: "Game Management Dashboard",
    games: "Games",
    teams: "Teams",
    selectGame: "Select game",
    noGames: "No games available",
    gameStatus: {
      draft: "Draft",
      ready: "Ready",
      active: "Active",
      paused: "Paused",
      finished: "Finished"
    },
    actions: {
      startGame: "Start Game",
      pauseGame: "Pause Game",
      resumeGame: "Resume Game",
      endGame: "End Game",
      refreshData: "Refresh Data"
    },
    confirmStart: "Are you sure you want to start the game?",
    confirmEnd: "Are you sure you want to end the game? This action cannot be undone.",
    gameStarted: "Game has been started",
    gameEnded: "Game has been ended",
    logout: "Log out"
  },

  validation: {
    teamNameRequired: "Team name is required",
    teamNameMinLength: "Team name must be at least 2 characters",
    teamNameMaxLength: "Team name can be at most 50 characters",
    passwordMinLength: "Password must be at least 4 characters",
    passwordRequired: "Password is required",
    tileNumberRequired: "Tile number is required",
    tileNumberInvalid: "Invalid tile number",
    answerRequired: "Answer is required",
    answerMaxLength: "Answer can be at most 500 characters",
    usernameRequired: "Username is required"
  },

  errors: {
    loginFailed: "Login failed. Check your credentials.",
    networkError: "Network error. Check your internet connection.",
    serverError: "Server error. Please try again later.",
    sessionExpired: "Session expired. Please log in again.",
    sessionInvalidated: "Your session has ended - logged in from another device.",
    unknownError: "An unknown error occurred.",
    gameNotFound: "Game not found.",
    teamNotFound: "Team not found.",
    alreadySubmitted: "Answer already submitted for this tile.",
    gameNotActive: "Game is not active."
  },

  offline: {
    checkConnection: "Check your connection and try again"
  },

  notifications: {
    answerCorrect: "Well done! Correct answer!",
    answerIncorrect: "Sorry, incorrect answer. Try again.",
    pointsEarned: "Earned {points} points!",
    newChallenge: "New challenge available!",
    gameStarted: "Game started! Good luck!",
    gameEnded: "Game ended. Check your score.",
    connectionRestored: "Connection restored."
  },

  completion: {
    congratulations: "Congratulations!",
    youCompleted: "you completed the game",
    stopCode: "Stop Code",
    showToOperator: "Show this code to the game operator",
    points: "Points",
    ranking: "Ranking",
    firstPlace: "First place! 🏆",
    secondPlace: "Second place! 🥈",
    thirdPlace: "Third place! 🥉",
    place: "place",
    awesome: "Awesome!"
  },

  stopCode: {
    enterCode: "Enter stop code",
    allSolvedHint: "You solved all puzzles! Calculate the code and stop the clock.",
    calculateHint: "Use the formula card to calculate the 6-digit code from collected digits",
    stopClock: "Stop clock",
    checking: "Checking...",
    wrongCode: "Wrong code. Check your calculations and try again.",
    connectionError: "Connection error. Please try again.",
    congratulations: "CONGRATULATIONS!",
    clockStopped: "you stopped the clock!",
    yourTime: "Your time",
    waitForResults: "Wait for the operator to announce the results",
    closeHint: "Close and return to game"
  },

  teamsProgress: {
    title: "Teams progress",
    solvedCount: "solved",
    yourTeam: "Your team",
    noTeams: "No other teams",
    // New keys
    congratulations: "Congratulations!",
    youFinished: "You finished the game!",
    resultsAtFinish: "You'll see results at the finish line!",
    rankingHidden: "Ranking is now hidden. Wait for results announcement by the organizer.",
    rankingFrozen: "Ranking frozen!",
    rankingFrozenDesc: "Ranking is frozen {{minutes}} minutes before game ends. Give it your all!",
    otherTeams: "other teams",
    nextRefreshIn: "Next refresh in",
    dataRefreshedEvery: "Data refreshed every {{minutes}} minutes",
    rankingFrozenUntilEnd: "Ranking frozen until game ends",
    teamPhotoAlt: "Photo of team {{name}}",
    tapToClose: "Tap to close"
  },

  movementDiagram: {
    title: "Movement Diagram",
    efficiency: "Route efficiency",
    time: "Time",
    optimalRoute: "Optimal route",
    teamRoute: "Team route",
    solvedCount: "Solved {{solved}} of {{total}} points",
    showDiagram: "Show movement diagram",
    noOptimalRoute: "No optimal route defined"
  },

  phoneVerification: {
    title: "Enter your phone number",
    subtitle: "Phone number is required for communication during the game.",
    phoneNumber: "Phone number",
    phonePlaceholder: "123 456 789",
    phoneHint: "Format: +48 XXX XXX XXX",
    submit: "Save and continue",
    submitting: "Saving...",
    errorInvalidFormat: "Invalid format. Use format: +48 XXX XXX XXX",
    success: "Phone number saved"
  },

  // New section for game ended modal
  gameEnded: {
    end: "THE END!",
    timeUp: "Game time is up.",
    goToFinish: "Head to the finish line as fast as possible!",
    moreInfoSms: "More info in SMS.",
    gameFinished: "Game finished"
  },

  // New section for team photo upload
  teamPhoto: {
    header: "THIS IS HOW OTHER TEAMS SEE YOU:",
    visibleInRanking: "Other teams will see this photo in ranking",
    noPhoto: "No photo - add yours!",
    photoAlt: "Your team photo",
    uploading: "Uploading...",
    changePhoto: "Change photo",
    addPhoto: "Add team photo",
    cameraOrGallery: "You can take a photo or choose from gallery",
    invalidFormat: "Invalid file format. Use JPG, PNG, GIF or WebP.",
    tooLarge: "Photo is too large. Maximum size is 5MB.",
    saved: "Photo saved!",
    uploadError: "Error uploading photo"
  },

  // Selfservice ranking
  selfserviceRanking: {
    beFirst: "Be one of the first!",
    notEnoughTeams: "Not enough teams have completed this game to show ranking.",
    finishAndSetTime: "Finish the game and set your time!",
    teamsCount: "So far:",
    team: "team",
    teams234: "teams",
    teams5plus: "teams",
    bestTime: "Best time",
    avgTime: "Avg time",
    teamsLabel: "Teams",
    top5: "TOP 5",
    you: "You",
    puzzles: "puzzles",
    estimatedPosition: "Estimated position",
    basedOnPace: "Based on your current pace",
    refreshRanking: "Refresh ranking",
    tryAgain: "Try again"
  },

  // Motivational popups
  motivational: {
    oneOfFirst: "You're one of the first teams!",
    haveFun: "Have fun and set the best time!",
    allSolved: "All puzzles solved!",
    enterStopCode: "Quick - enter the STOP CODE!",
    almostDone: "Almost done!",
    remaining: "{count} puzzles left.",
    fastestTime: "Fastest time is {time}. Can you beat it?",
    giveYourBest: "Give it your all!",
    betterThan: "You have {yours} puzzles - better than {percentile}% of teams!",
    keepItUp: "Great pace, keep it up!",
    greatPace: "Great pace!",
    othersHadAvg: "Other teams had an average of {avg} puzzles at this point.",
    othersHadMore: "Other teams had an average of {avg} puzzles at this time.",
    speedUp: "You have {yours} - speed up!",
    youHave: "You have {yours} puzzles solved.",
    avgAtThisPoint: "Average is {avg} at this point in the game.",
    yourTeam: "You",
    average: "Avg"
  },

  // Solari Board (public ranking)
  solariBoard: {
    title: "Global Ranking",
    selectCity: "Select city",
    position: "POS",
    team: "TEAM",
    time: "TIME",
    date: "DATE",
    totalTeams: "Total teams",
    bestTime: "Best time",
    noResults: "No results",
    filterAll: "All",
    filterSolo: "Solo",
    filterGroup: "Groups",
    loading: "Loading ranking...",
    penalty: "penalty",
  },

  // Chat with organizer
  chat: {
    title: "Chat with organizer",
    tabTitle: "Chat",
    noMessages: "No messages",
    startConversation: "Start a conversation with the organizer",
    typeMessage: "Type a message...",
    send: "Send",
    sending: "Sending...",
    attachImage: "Attach image",
    newMessage: "New message",
    operator: "Organizer",
    you: "You",
    today: "Today",
    yesterday: "Yesterday",
    imageUploading: "Uploading image...",
    messageSent: "Sent",
    messageError: "Send error",
    connectionError: "Connection error. Please try again.",
    loadError: "Failed to load messages",
    emptyMessage: "Message cannot be empty",
    imageTooLarge: "Image is too large. Maximum size is 5MB.",
    invalidImageFormat: "Invalid format. Use JPG, PNG, GIF or WebP.",
    compressingImage: "Compressing image...",
    clickToEnlarge: "Click to enlarge",
    closeImage: "Close",
    tapToOpen: "Tap to open chat"
  }
} as const;
